
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/AkkhorLayout";
import List from "../../component/List";


export default function PipelineSetting() {
  let params = 'orderby=position-asc';
  const columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    { name: "title", label: "Tiêu đề", options: { filter: true, sort: true } },
    { name: "alias", label: "Rút gọn", options: { filter: true, sort: true } },
    { name: "position", label: "Vị trí", options: { filter: true, sort: true } },
    { name: "datecreate",label: "Ngày tạo",}
  ];
  
  return (<AkkhorLayout idrole="pipeline_settings">
    <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Cài đặt Pipeline
                </li>
            </ul>
        </div>
    <List name="pipeline_settings" idrole="pipeline_settings" params={params} title="" defaultLimit={50}  serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
